import { render } from "./attendance-type.vue?vue&type=template&id=180bdb61"
import script from "./attendance-type.vue?vue&type=script&lang=js"
export * from "./attendance-type.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__